module.exports = __webpack_public_path__ + "notfound-4ac6bbec7a141c20c8c2.png";